/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSpecialPlaceCommand
 */
export interface CreateSpecialPlaceCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateSpecialPlaceCommand
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpecialPlaceCommand
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpecialPlaceCommand
     */
    description?: string | null;
}

export function CreateSpecialPlaceCommandFromJSON(json: any): CreateSpecialPlaceCommand {
    return CreateSpecialPlaceCommandFromJSONTyped(json, false);
}

export function CreateSpecialPlaceCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSpecialPlaceCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function CreateSpecialPlaceCommandToJSON(value?: CreateSpecialPlaceCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
    };
}


